const initialState = {
  innerdress: {},
  cart: [],
  packages: [],
  personalised: [],
  services: {},
  subservices: {},
  checkoutstatus: 0,
};

if (typeof window != "undefined") {
  if (localStorage.getItem("innerdress")) {
    initialState.innerdress = JSON.parse(localStorage.getItem("innerdress"));
  }

  if (localStorage.getItem("cart")) {
    initialState.cart = JSON.parse(localStorage.getItem("cart"));
  }
  if (localStorage.getItem("packages")) {
    initialState.packages = JSON.parse(localStorage.getItem("packages"));
  }
  if (localStorage.getItem("services")) {
    initialState.services = JSON.parse(localStorage.getItem("services"));
  }
  if (localStorage.getItem("checkoutstatus")) {
    initialState.checkoutstatus = JSON.parse(
      localStorage.getItem("checkoutstatus")
    );
  }
  if (localStorage.getItem("subservices")) {
    initialState.subservices = JSON.parse(localStorage.getItem("subservices"));
  }
  // FIXED: This was setting packages instead of personalised
  if (localStorage.getItem("personalised")) {
    initialState.personalised = JSON.parse(
      localStorage.getItem("personalised")
    );
  }
}

const dressReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_DRESS":
      console.log(action);
      localStorage.setItem("innerdress", JSON.stringify(action.payload));
      return {
        ...state,
        innerdress: action.payload,
      };

    case "ADD_TO_CART":
      if (
        state.cart.findIndex(
          (item) =>
            item.productid == action.payload.productid &&
            item.packages == action.payload.packages
        ) >= 0
      ) {
        var itemIndex = state.cart.findIndex(
          (item) =>
            item.productid == action.payload.productid &&
            item.packages == action.payload.packages
        );
        if (state.cart[itemIndex].packages == action.payload.packages) {
          var cartquantity = state.cart[itemIndex].cartquantity + 1;
          // ✅ FIX: Round to 2 decimal places to avoid floating point precision issues
          var cartamount = parseFloat(
            (state.cart[itemIndex].price * cartquantity).toFixed(2)
          );
          state.cart[itemIndex] = {
            ...action.payload,
            cartquantity: cartquantity,
            cartamount: cartamount,
          };
        } else {
          state.cart[itemIndex] = {
            ...action.payload,
            cartquantity: state.cart[itemIndex].cartquantity,
          };
        }
      } else {
        state.cart.push({ ...action.payload });
      }
      localStorage.setItem("cart", JSON.stringify(state.cart));
      return {
        ...state,
        cart: state.cart,
      };

    // NEW: Replace cart item instead of adding to quantity
    case "REPLACE_CART_ITEM":
      const existingItemIndex = state.cart.findIndex(
        (item) => item.productid === action.payload.productid
      );

      if (existingItemIndex >= 0) {
        // Replace the existing item
        state.cart[existingItemIndex] = {
          ...action.payload,
          cartquantity: 1,
          cartamount: action.payload.price,
        };
      } else {
        // Add new item
        state.cart.push({ ...action.payload });
      }

      localStorage.setItem("cart", JSON.stringify(state.cart));
      return {
        ...state,
        cart: [...state.cart],
      };

    case "ADD_PACKAGES":
      if (
        state.packages.findIndex(
          (item) =>
            item.id == action.payload.id &&
            item.ustring == action.payload.ustring
        ) >= 0
      ) {
        var itemIndex = state.packages.findIndex(
          (item) =>
            item.id == action.payload.id &&
            item.ustring == action.payload.ustring
        );
        var cartquantity = state.packages[itemIndex].cartquantity + 1;
        // ✅ FIX: Round to 2 decimal places
        var cartamount = parseFloat(
          (state.packages[itemIndex].amount * cartquantity).toFixed(2)
        );
        state.packages[itemIndex] = {
          ...action.payload,
          cartquantity: cartquantity,
          cartamount: cartamount,
        };
      } else {
        state.packages.push({
          ...action.payload,
          cartamount: action.payload.amount,
          cartquantity: state.cart?.find(
            (item) =>
              item.productid == action.payload.productid &&
              item.packages == action.payload.ustring
          )?.cartquantity,
        });
      }
      localStorage.setItem("packages", JSON.stringify(state.packages));
      return {
        ...state,
        packages: state.packages,
      };

    case "MINUS_TO_CART":
      if (
        state.cart.findIndex(
          (item) =>
            item.productid == action.payload.productid &&
            item.packages == action.payload.packages
        ) >= 0
      ) {
        var itemIndex = state.cart.findIndex(
          (item) =>
            item.productid == action.payload.productid &&
            item.packages == action.payload.packages
        );
        if (state.cart[itemIndex].packages == action.payload.packages) {
          var cartquantity = state.cart[itemIndex].cartquantity - 1;
          if (cartquantity <= 0) {
            cartquantity = 0;
            state.cart.splice(itemIndex, 1);
            localStorage.setItem("cart", JSON.stringify(state.cart));
            return {
              ...state,
              cart: state.cart,
            };
          }
          // ✅ FIX: Round to 2 decimal places to avoid floating point precision issues
          var cartamount = parseFloat(
            (state.cart[itemIndex].price * cartquantity).toFixed(2)
          );
          state.cart[itemIndex] = {
            ...action.payload,
            cartquantity: cartquantity,
            cartamount: cartamount,
          };
        } else {
          state.cart[itemIndex] = {
            ...action.payload,
            cartquantity: state.cart[itemIndex].cartquantity,
          };
        }
      } else {
        state.cart.push({ ...action.payload });
      }
      localStorage.setItem("cart", JSON.stringify(state.cart));
      return {
        ...state,
        cart: state.cart,
      };

    case "MINUS_PACKAGES":
      if (
        state.packages.findIndex(
          (item) =>
            item.id == action.payload.id &&
            item.ustring == action.payload.ustring
        ) >= 0
      ) {
        var itemIndex = state.packages.findIndex(
          (item) =>
            item.id == action.payload.id &&
            item.ustring == action.payload.ustring
        );
        var cartquantity = state.packages[itemIndex].cartquantity - 1;
        // ✅ FIX: Round to 2 decimal places
        var cartamount = parseFloat(
          (state.packages[itemIndex].amount * cartquantity).toFixed(2)
        );

        if (cartquantity <= 0) {
          cartquantity = 0;
          state.packages.splice(itemIndex, 1);
          localStorage.setItem("packages", JSON.stringify(state.packages));
          return {
            ...state,
            packages: state.packages,
          };
        }

        state.packages[itemIndex] = {
          ...action.payload,
          cartquantity: cartquantity,
          cartamount: cartamount,
        };
      } else {
        state.packages.push({
          ...action.payload,
          cartamount: action.payload.amount,
          cartquantity: state.cart?.find(
            (item) =>
              item.productid == action.payload.productid &&
              item.packages == action.payload.ustring
          )?.cartquantity,
        });
      }
      localStorage.setItem("packages", JSON.stringify(state.packages));
      return {
        ...state,
        packages: state.packages,
      };

    case "ADD_SERVICES":
      console.log(action);
      localStorage.setItem("services", JSON.stringify(action.payload));
      return {
        ...state,
        services: action.payload,
      };

    case "ADD_SUB_SERVICES":
      console.log(action);
      localStorage.setItem("subservices", JSON.stringify(action.payload));
      return {
        ...state,
        subservices: action.payload,
      };

    case "CHECKOUT_STATUS":
      localStorage.setItem("checkoutstatus", JSON.stringify(action.payload));
      return {
        ...state,
        checkoutstatus: action.payload,
      };

    case "MINUS_PACKAGES_WITH_CART":
      if (
        state.packages.findIndex(
          (item) =>
            item.productid == action.payload.productid &&
            item.ustring == action.payload.ustring
        ) >= 0
      ) {
        var itemIndex = state.packages.findIndex(
          (item) =>
            item.productid == action.payload.productid &&
            item.ustring == action.payload.ustring
        );

        if (
          state.cart?.find(
            (item) =>
              item.productid == action.payload.productid &&
              item.packages == action.payload.ustring
          )?.cartquantity
        ) {
          var cartquantity = state.packages[itemIndex].cartquantity - 1;
          // ✅ FIX: Round to 2 decimal places
          var cartamount = parseFloat(
            (state.packages[itemIndex].amount * cartquantity).toFixed(2)
          );
        } else {
          var cartquantity = 0;
          var cartamount = 0;
        }

        if (cartquantity <= 0) {
          cartquantity = 0;
          state.packages = state.packages.filter(
            (item) =>
              item.productid !== action.payload.productid &&
              item.ustring !== action.payload.ustring
          );
          localStorage.setItem("packages", JSON.stringify(state.packages));
          return {
            ...state,
            packages: state.packages,
          };
        }

        state.packages[itemIndex] = {
          ...state.packages[itemIndex],
          cartquantity: cartquantity,
          cartamount: cartamount,
        };
      }
      localStorage.setItem("packages", JSON.stringify(state.packages));
      return {
        ...state,
        packages: state.packages,
      };

    case "ADD_PERSONALISED":
      if (
        state.personalised.findIndex((item) => item.id == action.payload.id) >=
        0
      ) {
        var itemIndex = state.personalised.findIndex(
          (item) => item.id == action.payload.id
        );
        var cartquantity = state.personalised[itemIndex].cartquantity + 1;
        // ✅ FIX: Round to 2 decimal places
        var cartamount = parseFloat(
          (state.personalised[itemIndex].amount * cartquantity).toFixed(2)
        );
        state.personalised[itemIndex] = {
          ...action.payload,
          cartquantity: cartquantity,
          cartamount: cartamount,
        };
      } else {
        state.personalised.push({
          ...action.payload,
          cartamount: action.payload.amount,
          cartquantity: 1,
        });
      }
      localStorage.setItem("personalised", JSON.stringify(state.personalised));
      return {
        ...state,
        personalised: state.personalised,
      };

    case "MINUS_PERSONALISED":
      if (
        state.personalised.findIndex((item) => item.id == action.payload.id) >=
        0
      ) {
        var itemIndex = state.personalised.findIndex(
          (item) => item.id == action.payload.id
        );
        var cartquantity = state.personalised[itemIndex].cartquantity - 1;
        // ✅ FIX: Round to 2 decimal places
        var cartamount = parseFloat(
          (state.personalised[itemIndex].amount * cartquantity).toFixed(2)
        );

        if (cartquantity <= 0) {
          cartquantity = 0;
          state.personalised.splice(itemIndex, 1);
          localStorage.setItem(
            "personalised",
            JSON.stringify(state.personalised)
          );
          return {
            ...state,
            personalised: state.personalised,
          };
        }

        state.personalised[itemIndex] = {
          ...action.payload,
          cartquantity: cartquantity,
          cartamount: cartamount,
        };
      } else {
        state.personalised.push({
          ...action.payload,
          cartamount: action.payload.amount,
          cartquantity: 0,
        });
      }
      localStorage.setItem("personalised", JSON.stringify(state.personalised));
      return {
        ...state,
        personalised: state.personalised,
      };

    // CLEAR ACTIONS - FIXED AND CONSOLIDATED
    case "CLEAR_CART":
      localStorage.removeItem("cart");
      return {
        ...state,
        cart: [],
      };

    case "CLEAR_PACKAGES":
      localStorage.removeItem("packages");
      return {
        ...state,
        packages: [],
      };

    case "CLEAR_PERSONALISED":
      localStorage.removeItem("personalised");
      return {
        ...state,
        personalised: [],
      };

    case "CLEAR_SERVICES":
      localStorage.removeItem("services");
      localStorage.removeItem("subservices");
      return {
        ...state,
        services: {},
        subservices: {},
      };

    // NEW: Clear a single cart item
    case "CLEAR_SINGLE_CART_ITEM":
      const updatedCart = state.cart.filter(
        (item) =>
          !(
            item.productid === action.payload.productid &&
            item.packages === action.payload.packages
          )
      );
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      return {
        ...state,
        cart: updatedCart,
      };

    // NEW: Clear packages for a specific product
    case "CLEAR_PACKAGES_FOR_PRODUCT":
      const updatedPackages = state.packages.filter(
        (item) =>
          !(
            item.productid === action.payload.productid &&
            item.ustring === action.payload.ustring
          )
      );
      localStorage.setItem("packages", JSON.stringify(updatedPackages));
      return {
        ...state,
        packages: updatedPackages,
      };

    default:
      return state;
  }
};

export default dressReducer;
